import { render } from "./WidgetsPanel.vue?vue&type=template&id=5d60d0f4"
import script from "./WidgetsPanel.vue?vue&type=script&lang=js"
export * from "./WidgetsPanel.vue?vue&type=script&lang=js"
script.render = render

export default script